<template>
  <div class="number-range-picker">
    <b-form-input v-model="from" type="number" size="sm" debounce="300" @update="valueUpdated" />
    <span>:</span>
    <b-form-input v-model="to" type="number" size="sm" debounce="300" @update="valueUpdated" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    value?: string | null;
  }>(),
  {
    value: ":",
  }
);

const emit = defineEmits<{
  (e: "input", value: string | null): void;
}>();

function parseValue(value: string | null) {
  if (!value) {
    return { from: null as string | null, to: null as string | null };
  }

  const fromMatch = value.match(/([0-9.]+):/);
  const toMatch = value.match(/.*:([0-9.]+)/);
  return {
    from: fromMatch ? fromMatch[1] : null,
    to: toMatch ? toMatch[1] : null,
  };
}

const parsed = parseValue(props.value);
const from = ref(parsed.from);
const to = ref(parsed.to);

watch(
  () => props.value,
  (newValue) => {
    const parsed = parseValue(newValue);
    from.value = parsed.from;
    to.value = parsed.to;
  }
);

function valueUpdated() {
  if (!from.value && !to.value) {
    return emit("input", null);
  }

  emit("input", `${from.value ? from.value : ""}:${to.value ? to.value : ""}`);
}
</script>

<style lang="scss">
.number-range-picker {
  display: flex;
  flex: 1;

  > span {
    flex-shrink: 1;
    margin: auto 3px;
  }
}
</style>
